import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaCamera } from "react-icons/fa";
import { useSelector } from "react-redux";
import Api from "../../components/api/Api";
import axios from "axios";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import UserProfile from "./UserProfile";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Avatar from "../../components/notes/Avatar";
import "./profile.css";
import { FaEnvelope, FaWhatsapp, FaCheckCircle, FaTimesCircle, FaCity, FaMapMarkerAlt, FaCreditCard } from "react-icons/fa";
import { BiSolidUserDetail } from "react-icons/bi";
import { IoDocumentAttach } from "react-icons/io5";

const Profile = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const [userDetails, setUserDetails] = useState();
  const [assetUrl, setAssetUrl] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const userId = loggedInUser?.user?.id;
  // console.log("Logged in user ID:", userId); 
  // const token = loggedInUser?.token;
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [profilePicture, setProfilePicture] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [subscriptionDetails, setSubscriptionDetails] = useState();
  const isPartner = true;

  const getDetailsApi = Api({
    url: `admin/user/id/${userId}`,
  });

  useEffect(() => {
    fetchData();
    fetchSubscriptionDetails();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const responseData = await getDetailsApi.fetchData(); 
      console.log("User Details Response:", responseData.data);
      const user = responseData?.data;
      setUserDetails(user.user);
      setAssetUrl(user.assetUrl)
      setProfilePicture(assetUrl + user.user.photo);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleProfilePictureChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      // preview new image before uploading
      setProfilePicture(URL.createObjectURL(file));
    }
  };

  const handleProfilePictureUpload = async () => {
    if (!selectedFile) {
      showToast("Please select a profile picture", { type: "error" });
      return;
    }

    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("file", selectedFile);

    try {
      setUploading(true);
      const response = await axios.put(
        `${baseUrl}/admin/changePicture`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response?.data?.statusType === "SUCCESS") {
        showToast("Profile Picture Uploaded successfully", { type: "success" });
        fetchData();
        setSelectedFile(null);
      } else {
        showToast("Some Error Occurred! Please Try Again", { type: "error" });
      }
    } catch (error) {
      console.error("Upload error:", error);
      showToast("Upload failed!", { type: "error" });
    } finally {
      setUploading(false);
    }
  };

  const fetchSubscriptionDetails = async () => {
      try{
        const response = await axios.get(`${baseUrl}/payments/subscriptions/user/${userId}`);
        setSubscriptionDetails(response?.data);
        console.log("Subscription details:", subscriptionDetails);
      }catch (error) {
      console.error("Error fetching subscription details:", error);
    }
  };
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Profile", link: "/user/profile", active: true },
  ];

  return (
    <>
      <Notification/>
      <Container fluid>
        <BreadCrumb items={breadcrumbItems} />

        <Row className="justify-content-center">
          <Col md={4} lg={3}>
            <UserProfile />
          </Col>

          <Col xs={12} md={8} lg={8}>
            <div className="card shadow border-0 rounded-3 p-4 my-2 profile-card">
              <div className="text-center mb-4">
                <div className="position-relative d-inline-block">
                  <Avatar
                    src={profilePicture}
                    icon={`${userDetails?.first_name || ""} ${userDetails?.last_name || ""}`}
                    size={150}
                    className="rounded-circle border border-3 border-light shadow-sm"
                  />
                  <div className="upload-btn-wrapper">
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle p-2 mt-2 shadow-sm"
                    >
                      <FaCamera size={16} />
                    </Button>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleProfilePictureChange}
                    />
                  </div>
                </div>

                {/* Upload button should only appear when new image is selected */}
                {selectedFile && (
                  <div className="text-center mt-3">
                    <button
                      type="button"
                      onClick={handleProfilePictureUpload}
                      disabled={uploading}
                      className="btn btn-primary px-4"
                    >
                      {uploading ? "Uploading..." : "Upload Profile Picture"}
                    </button>
                  </div>
                )}

                <h4 className="mt-3">
                  {userDetails?.first_name} {userDetails?.last_name}
                </h4>
                <p className="text-muted mb-1">
                  {userDetails?.userType?.name.replace("_", " ")}
                </p>
              </div>

              <hr />

              <div className="user-details px-2 px-md-4 py-3">
                <h6 className="fw-bold mb-2 border-bottom pb-1 ">
                  <BiSolidUserDetail  className="me-2 text-secondary fs-4" />
                  User Details
                </h6>   
                <DetailRow
                  icon={<FaEnvelope />}
                  label="Email"
                  value={userDetails?.email_address}
                  verified={userDetails?.email_verified}
                  color="primary"
                />

                <DetailRow
                  icon={<FaWhatsapp />}
                  label="WhatsApp"
                  value={userDetails?.whatsapp_mobile_number}
                  color="success"
                />

                <DetailRow
                  icon={<FaMapMarkerAlt />}
                  label="State"
                  value={userDetails?.cities?.[0]?.state?.name}
                  color="warning"
                />

                <DetailRow
                  icon={<FaCity />}
                  label="City"
                  value={userDetails?.cities?.[0]?.name}
                  color="info"
                />

                {isPartner && (
                  <>
                    <h6 className="fw-bold mt-4 mb-2 border-bottom pb-1">
                      <IoDocumentAttach  className="me-2 text-secondary" />
                      Documents
                    </h6>
                    {userDetails?.documents && userDetails?.documents.length > 0 ? (
                      <div className="row g-3">
                        {userDetails.documents.map((doc, index) => (
                          <div key={index} className="col-12 col-md-4">
                          <div className="document-thumbnail d-flex justify-content-center align-items-center flex-column">
                            <img
                              src={assetUrl + doc.document_url}
                              alt={doc.name}
                              className="img-fluid rounded-3 shadow-sm"
                              style={{ maxHeight: '120px', objectFit: 'cover' }}
                            />
                            <div className="document-info mt-2 text-center">
                              <h6 className="text-truncate" style={{ fontSize: '0.875rem' }}>{doc.name}</h6>
                            </div>
                          </div>
                        </div>
                        ))}
                      </div> 
                    ) : (
                      <div className="col-12">
                        <div className="alert alert-danger" role="alert">
                          No documents available.
                        </div>
                      </div>
                    )}  


                    <h6 className="fw-bold mt-4 mb-2 border-bottom pb-1">
                      <FaCreditCard className="me-2 text-secondary" />
                      Subscription Details
                    </h6>
                    {subscriptionDetails?.subscriptionPlanActive ? (
                      <div className="card shadow-sm border-0 rounded-3 bg-light p-4 mt-2">
                        <h5 className="">Subscription Status</h5>
                        {/* Display status type */}
                        <div className="mb-3">
                          <span className={`badge ${subscriptionDetails.statusType === 'SUCCESS' ? 'bg-success' : 'bg-danger'} text-white`}>
                            active
                          </span>
                        </div>
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <p className="text-muted mb-1"><strong>Plan Name:</strong> {subscriptionDetails.subscriptionPlan.name}</p>
                          </div>
                          <div className="col-12 col-md-6">
                            <p className="text-muted mb-1"><strong>Remaining Days:</strong> {subscriptionDetails.effectiveSubscriptionDays}</p>
                          </div>
                          <div className="col-12 col-md-6">
                            {/* <p className="text-muted mb-1"><strong>Duration (Days):</strong> {subscriptionDetails.subscriptionPlan.duration_in_days}</p> */}
                            <p className="text-muted mb-1"><strong>Duration (Days):</strong> {subscriptionDetails.durationInDays}</p>
                          </div>
                          <div className="col-12 col-md-6">
                            <p className="text-muted mb-1"><strong>Price:</strong> ₹{subscriptionDetails.subscriptionPlan.price}</p>
                          </div>
                          <div className="col-12 col-md-6">
                            <p className="text-muted mb-1"><strong>GST:</strong> ₹{subscriptionDetails.subscriptionPlan.gst}</p>
                          </div>
                          <div className="col-12 col-md-6">
                            <p className="text-muted mb-1"><strong>Total Price:</strong> ₹{subscriptionDetails.subscriptionPlan.total_price}</p>
                          </div>
                        </div>
                        {/* <div className="mt-4">
                          <button className="btn btn-primary">Manage Subscription</button>
                        </div> */}
                              
                      </div>
                      ):(
                      <div className="col-12">
                        <div className="alert alert-warning" role="alert">
                          No subscription plan active. 
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>             
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Profile;

const DetailRow = ({ icon, label, value, color = "primary", verified }) => (
  <div className="d-flex flex-wrap align-items-center py-2">
    <div className="d-flex align-items-center mb-1 mb-md-0">
      <div className={`detail-icon detail-icon-${color} me-2`}>
        {icon}
      </div>
      <span className="fw-semibold text-secondary">{label}</span>
      {verified !== undefined &&
        (verified ? (
          <FaCheckCircle className="text-success ms-2" title="Verified" />
        ) : (
          <FaTimesCircle className="text-danger ms-2" title="Not Verified" />
        ))}
    </div>
    <div className="text-md text-muted px-2">
      {value || <span className="fst-italic text-muted">Not provided</span>}
    </div>
  </div>
);